(function() {
  function initAccordion(scope) {
    // Find all accordion items within the scope
    const items = scope.querySelectorAll('.da-mt-accordion-item');
    
    items.forEach(item => {
      // Prevent double initialization
      if (item.hasAttribute('data-initialized')) return;
      item.setAttribute('data-initialized', 'true');

      const header = item.querySelector('.da-mt-accordion-header');
      const content = item.querySelector('.da-mt-accordion-content');
      
      if (!header || !content) return;

      // Initial state setup
      if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      } else {
        content.style.maxHeight = null;
        header.setAttribute('aria-expanded', 'false');
      }

      // Click handler
      header.addEventListener('click', function(e) {
        e.preventDefault(); // Good practice for buttons
        
        const isActive = item.classList.contains('active');
        
        if (isActive) {
          // Close
          item.classList.remove('active');
          content.style.maxHeight = null;
          header.setAttribute('aria-expanded', 'false');
        } else {
          // Open
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAccordion(document);
    });
  } else {
    initAccordion(document);
  }

  // Initialize on Shopify Theme Editor events
  document.addEventListener('shopify:section:load', function(e) {
    initAccordion(e.target);
  });
})();
